<template>
    <div class="flex flex-col">
      <!-- Might need to add overflow-y-hidden to the div above here if anything is broken (i removeed it, but not sure why it was thre) -->
    <InternalRightSidebar :visible="showFilters" :allow-overflow="true" @close="toggleShowFilters">
      <div>
        <SectionHeader>
          <template #left>
            <h1 class="text-md text-base-content">Filters</h1>
          </template>
          <template #right>
            <button
              class="cursor-pointer te text-md p-1 -m-1 text-base-content/20 hover:text-primary"
              @click="toggleShowFilters"
            >
              <v-icon name="hi-arrow-sm-right" height="1.5em" width="1.5em" />
            </button>
          </template>
        </SectionHeader>
        
        <!-- Filters -->
        <div class="mt-4 space-y-4">
          <!-- Filter Grid -->
          <div class="grid grid-cols-1 gap-3">
            <MultiSelect
              id="countries"
              v-model="countries"
              input-label="Countries"
              :options="countryOptions"
              filter
              placeholder="Countries"
              track-by="id"
              label="label"
              :maxSelectedLabels="3"
              :multiple="true"
            />
            
            <MultiSelect
              id="campaigns"
              track-by="id"
              label="label"
              input-label="Campaign"
              placeholder="Campaign"
              v-model="campaignFilter"
              :options="campaignOptions"
              :multiple="true"
            />
            
          
            <XInput
              type="text"
              name="Usage Type"
              id="usagetype"
              label="Usage Type"
              v-model="usageTypeFilter"
            />
            
            <XInput
              type="text"
              name="Sub Id"
              id="subid"
              label="Sub ID"
              v-model="subIdFilter"
            />
            
            <XInput
              type="text"
              name="Keyword"
              id="keyword"
              label="Keyword"
              v-model="keywordFilter"
            />
          </div>
          
          <!-- Action Buttons -->
          <div class="flex gap-2 justify-end">
            <XButton
              class="btn btn-ghost hover:bg-neutral/20 text-base-content/30 hover:text-base-content/70"
              @click="resetFilters"
            >
              Reset Filters
            </XButton>
            <XButton
              color="primary"
              @click="refreshReportData"
              :is-loading="loading"
            >
              Submit
            </XButton>
          </div>
        </div>
      </div>
    </InternalRightSidebar>
    <SectionHeader container-class="flex-0">
      <template #left>
        <h1 class="text-md text-base-content">Reports</h1>
      </template>
      <template #right>
        <div class="flex items-center gap-2">
          <div class="dropdown dropdown-end">
            <button
              tabindex="0"
              v-tooltip="'Export Report Data'"
              class="p-2 rounded-full cursor-pointer text-base-content/20 hover:text-accent hover:scale-110 shadow-none transition transform duration-500 ease-in-out"
            >
              <v-icon name="hi-download" scale="1.45" />
            </button>
            <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-50 w-44 p-1 shadow border border-base-300">
              <li>
                <a @click="exportAsJson" class="text-xs">
                  <v-icon name="bi-braces" scale="1" />
                  Export as JSON
                </a>
              </li>
              <li>
                <a @click="exportAsCsv" class="text-xs">
                  <v-icon name="md-tableview-outlined" scale="1" />
                  Export as CSV
                </a>
              </li>
            </ul>
          </div>
          <button
            v-tooltip="showFilters ? `Hide Filters` : 'Show Filters'"
            @click="toggleShowFilters"
            :class="[
              showFilters ? 'text-accent' : 'text-base-content/20',
              'p-2 rounded-full cursor-pointer hover:text-accent hover:scale-110 shadow-none transition transform duration-500 ease-in-out relative',
            ]"
          >
            <v-icon name="md-filteralt-outlined" scale="1.45" class="cursor-pointer" />
            <span
              v-if="activeFiltersCount > 0"
              class="absolute top-1 right-1 text-base-100 bg-accent outline-base-100 outline text-xs rounded-full h-4 w-4 flex items-center justify-center font-medium text-[10px]"
            >
              {{ activeFiltersCount }}
            </span>
          </button>
        </div>
      </template>
    </SectionHeader>

    <!-- Date Range Picker and Show Columns -->
    <div class="mb-2 flex items-center justify-between gap-2">
      <div class="w-64 shrink-0 relative" ref="datePickerContainer" :class="{ 'z-[49]': datePickerOpen || isDatePickerAnimating }">
        <DateRangePicker 
          v-model="dateValue"
          :borderless="true"
          :overlay="true"
        ></DateRangePicker>
        
      </div>
      <!-- Desktop: Full MultiSelect -->
      <!-- <div class="hidden md:block flex-shrink min-w-0">
        <MultiSelect
          v-model="selectedColumns"
          :options="columnOptions"
          :multiple="true"
          label="label"
          track-by="name"
          inputLabel=""
          :borderless="true"
          :invisibleInput="true"
        />
      </div> -->
      <!-- Column Selector Dropdown with Overlay -->
      <DropdownWithOverlay 
        v-model="dropdownOpen"
        position="dropdown-end"
        :keep-open="true"
        content-class="bg-base-100 rounded-box z-[100] w-80 p-3 shadow-lg border border-base-300"
      >
        <template #trigger>
          <button class="btn btn-ghost btn-sm gap-2 normal-case font-normal text-base-content/80">
            <span class="text-sm font-normal">{{ selectedColumns.length }} columns</span>
            <svg class="w-3 h-3 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
        </template>
        
        <template #content>
          <!-- Selected Columns Display -->
          <div v-if="selectedColumns.length > 0" class="mb-3 pb-3 border-b border-base-300">
            <div class="text-xs font-medium mb-2 text-base-content/70">Selected Columns</div>
            <div class="flex flex-wrap gap-1">
              <span 
                v-for="column in selectedColumns" 
                :key="column.name"
                class="inline-flex items-center gap-1 px-2 py-0.5 text-xs bg-primary text-primary-content rounded relative  column-badge"
              >
                {{ column.label }}
                <a 
                  @click="toggleColumn(column)"
                  class="ml-0.5 hover:bg-primary-content/20 rounded-full p-0.5 -mr-1"
                >
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </a>
              </span>
            </div>
          </div>
          
          <!-- Column Selection -->
          <div class="text-xs font-medium mb-2 text-base-content/70">Available Columns</div>
          <div class="max-h-64 overflow-y-auto">
            <label 
              v-for="column in columnOptions" 
              :key="column.name"
              class="flex items-center gap-2 py-1.5 px-2 hover:bg-base-200 rounded cursor-pointer"
            >
              <input 
                type="checkbox" 
                class="checkbox checkbox-sm checkbox-primary"
                :checked="selectedColumns.some(c => c.name === column.name)"
                @change="toggleColumn(column)"
              />
              <span class="text-sm">{{ column.label }}</span>
            </label>
          </div>
        </template>
      </DropdownWithOverlay>
    </div>

    <div class="flex flex-col h-full mt-2">
    <XTable
      class="flex-grow bg-base-200"
      min-table-height="21.3rem"
      :data="reportResults || []"
      :is-loading="loading"
      emptyText="No data found for your search criteria"
    >
      <template v-slot:header-row>
        <th v-for="(key, index) in activeColumns" :key="key" class="th-node">
          <span v-if="inQuery(key.name)" class="th-span-node group">
            <button @click="tableSortBy(key.name)" class="uppercase flex items-center justify-between w-full h-full">
              <ArrowDownIcon
                  class="sort-icon group-hover:text-white"
                  :class="sortArrowStyle(key.name)"
                />
              <div class="flex-1 flex flex-col sm:flex-row items-start sm:items-center sm:justify-between gap-0 sm:gap-2">
                <span class="min-w-full sm:min-w-0 sm:w-auto text-left">
                  {{ key.label }}
                </span>
                <span class="block sm:inline font-semibold text-primary group-hover:text-white">{{ formatTableTotals(key.name, 0) }}</span>
              </div>
              <div>
              </div>
            </button>
          </span>
        </th>
      </template>
      <!-- <template v-slot:header-row-2>
        <th
            v-for="(key, index) in activeColumns"
            :key="key.name"
            class="border-b border-b-8 border-base-100 font-semibold bg-base-100 dark:text-white"
          >
            <div v-if="index == 0">
              <span>
                {{ formatTableTotals(key.name, index) }}
              </span>
            </div>
            <span v-else>
              {{ formatTableTotals(key.name, index) }}
            </span>
          </th>
      </template> -->
      <!-- <template v-slot:beforeBody>
        <tr>
          <td
            v-for="(key, index) in activeColumns"
            :key="key.name"
            class="border-b border-b-8 border-base-100 font-semibold bg-base-100 dark:text-white"
          >
            <div v-if="index == 0">
              <span>
                {{ formatTableTotals(key.name, index) }}
              </span>
            </div>
            <span v-else>
              {{ formatTableTotals(key.name, index) }}
            </span>
          </td>
        </tr>
      </template> -->
      <template v-slot:row="props">
        <td v-for="key in activeColumns" :key="key.name">
          {{ formatTableValues(props.row[key.name], key.name) }}
        </td>
      </template>
    </XTable>
  </div>
  </div>
</template>

<script setup>
import XInput from "@/components/common/XInput.vue"
import XButton from "@/components/common/XButton.vue"
import DropdownWithOverlay from "@/components/common/DropdownWithOverlay.vue"

import MultiSelect from "@/components/common/MultiSelect.vue"

import { useQuery, useLazyQuery } from "@vue/apollo-composable"
import { useAuthStore } from "@/stores/auth.js"
import { useSettingsStore } from "@/stores/settings.js"

import { ref, computed, onMounted, watch } from "vue"
import DateRangePicker from "@/components/common/DateRangePicker.vue"
import PUBLISHER_REPORT_QUERY from "@/graphql/Report/PublisherReports.gql"
import PUBLISHER_REDIRECTS_LITE_QUERY from "@/graphql/Redirect/PublisherRedirectsLite.gql"
import { DateTime } from "luxon"
import { formatCurrency } from "@/utils/formatCurrency"
import InternalRightSidebar from "@/components/common/InternalRightSidebar.vue"
import { objectToCsv, saveCsvString } from "@/assets/js/CsvTools.js"
import { saveAs } from "file-saver"

import {
  countryOptions,
} from "./constants/reportConstants.js"

import { ArrowDownIcon } from "@heroicons/vue/24/outline"

import {
  useUpdateRefVariable,
  useMakeReportFilter,
  useMakeReportFilterById,
} from "@/assets/js/utils.js"

const { settings, setSetting, toggleSetting } = useSettingsStore()


const authStore = useAuthStore()

const reportResults = ref("")
const reportTotals = ref("")

const dateValue = ref({
  start: DateTime.local().startOf("month").toFormat("yyyy-LL-dd"),
  end: DateTime.local().toFormat("yyyy-LL-dd"),
})


const showFilters = computed(() => {
  if(settings.reportsFiltersVisible === undefined) {
    return true;
  }
  return settings.reportsFiltersVisible 
})

const toggleShowFilters = () => {
  toggleSetting("reportsFiltersVisible")
}

// Track dropdown open state
const dropdownOpen = ref(false)

// Track date picker open state
const datePickerOpen = ref(false)
const datePickerContainer = ref(null)
const isDatePickerAnimating = ref(false)


// Compute active filters for display
const activeFilters = computed(() => {
  const filters = []
  
  if (countries.value && countries.value.length > 0) {
    filters.push({
      name: 'countries',
      label: 'Countries',
      value: countries.value.map(c => c.label || c).join(', ')
    })
  }
  
  if (campaignFilter.value && campaignFilter.value.length > 0) {
    filters.push({
      name: 'campaigns',
      label: 'Campaigns',
      value: campaignFilter.value.map(c => c.label || c).join(', ')
    })
  }
  
  if (payoutConversionFilter.value && payoutConversionFilter.value.length > 0) {
    filters.push({
      name: 'conversionType',
      label: 'Conversion Type',
      value: payoutConversionFilter.value.join(', ')
    })
  }
  
  if (usageTypeFilter.value) {
    filters.push({
      name: 'usageType',
      label: 'Usage Type',
      value: usageTypeFilter.value
    })
  }
  
  if (subIdFilter.value) {
    filters.push({
      name: 'subId',
      label: 'Sub ID',
      value: subIdFilter.value
    })
  }
  
  if (keywordFilter.value) {
    filters.push({
      name: 'keyword',
      label: 'Keyword',
      value: keywordFilter.value
    })
  }
  
  return filters
})

// Count individual filter values instead of filter types
const activeFiltersCount = computed(() => {
  let count = 0
  
  if (countries.value && countries.value.length > 0) {
    count += countries.value.length
  }
  
  if (campaignFilter.value && campaignFilter.value.length > 0) {
    count += campaignFilter.value.length
  }
  
  if (payoutConversionFilter.value && payoutConversionFilter.value.length > 0) {
    count += payoutConversionFilter.value.length
  }
  
  if (usageTypeFilter.value) {
    count += 1
  }
  
  if (subIdFilter.value) {
    count += 1
  }
  
  if (keywordFilter.value) {
    count += 1
  }
  
  return count
})

const formatTableValues = (value, columnName) => {
  if (columnName === "payout" || columnName === "ecpm") {
    return formatCurrency(value)
  }
  if (
    columnName === "visits" ||
    columnName === "publisherConversions"
  ) {
    return value ? value.toLocaleString() : "0"
  }
  return value ? value.toLocaleString() : ""
}

const formatTableTotals = (columnName, index) => {
  const totals = reportTotals.value || {}

  return totals.hasOwnProperty(columnName)
    ? columnName === "payout" || columnName === "ecpm"
      ? `${formatCurrency(totals[columnName])}`
      : totals[columnName]?.toLocaleString()
    : index === 0
    ? ""
    : ""
}

const paginatorInfo = ref([])
const totals = ref([])
let currentPage = ref(1)
let count = ref(10)
let totalPages = ref(1)
let campaignOptions = ref([])
let dataFields = []

const domainFilter = ref(null)
const campaignFilter = ref(null)
const payoutConversionFilter = ref(null)
const usageTypeFilter = ref(null)
const subIdFilter = ref(null)
const keywordFilter = ref(null)

const countries = ref(null)

const resetFilters = () => {
  countries.value = null
  campaignFilter.value = null
  payoutConversionFilter.value = null
  usageTypeFilter.value = null
  subIdFilter.value = null
  keywordFilter.value = null
}

const columnOptions = [
  { label: "Day", name: "day" },
  { label: "Month", name: "month" },
  { label: "Country", name: "country" },
  { label: "Campaign", name: "campaign" },
  { label: "Usage Type", name: "usageType" },
  { label: "Sub1", name: "sub1" },
  { label: "Sub2", name: "sub2" },
  { label: "Sub3", name: "sub3" },
  { label: "Sub4", name: "sub4" },
  { label: "Sub5", name: "sub5" },
  { label: "Keyword", name: "keyword" },
  { label: "Impressions", name: "visits" },
  { label: "Conversions", name: "publisherConversions" },
  { label: "eCPM", name: "ecpm" },
  { label: "Revenue", name: "payout" },
]

const selectedColumns = ref([
  { label: "Day", name: "day" },
  { label: "Impressions", name: "visits" },
  { label: "Conversions", name: "publisherConversions" },
  { label: "eCPM", name: "ecpm" },
  { label: "Revenue", name: "payout" },
])

const activeColumns = ref(selectedColumns.value)

const toggleColumn = (column) => {
  const index = selectedColumns.value.findIndex(c => c.name === column.name)
  if (index > -1) {
    selectedColumns.value.splice(index, 1)
  } else {
    selectedColumns.value.push(column)
  }
}

let tableSortByValue = ref([
  {
    field: "day",
    sortField: "day",
    direction: "desc",
  },
])

const tableSortBy = value => {
  if (loading.value) return
  const sortField = value
  const direction = "desc"

  if (
    tableSortByValue.value.length > 0 &&
    tableSortByValue.value[0].field === sortField
  ) {
    const newDirection =
      tableSortByValue.value[0].direction === "desc" ? "asc" : "desc"

    tableSortByValue.value[0].direction = newDirection
  } else {
    tableSortByValue.value = [
      {
        field: sortField,
        sortField: sortField,
        direction: direction,
      },
    ]
  }

  refreshReportData()
}

const sortArrowStyle = name => {
  const isSelected =
    tableSortByValue.value.length > 0 &&
    tableSortByValue.value[0].field === name
  const isAscending =
    isSelected && tableSortByValue.value[0].direction === "asc"

  return {
    "sort-icon-selected": isSelected,
    "rotate-180": isAscending,
  }
}

const updateSortFields = value => {
  if (!value || value.value === "") {
    return undefined
  }

  if (Array.isArray(value.value)) {
    value.value.sort(
      (a, b) =>
        columnOptions.findIndex(option => option.name === a.name) -
        columnOptions.findIndex(option => option.name === b.name),
    )

    const sortedValues = value.value.map(item => item.name)
    return sortedValues
  }
  return value.value
}

const inQuery = check => {
  const columnNames = activeColumns.value.map(variable => variable.name)
  return columnNames.includes(check)
}

const reportVariables = computed(() => {
  return {
    filters: {
      dateTimeRange: useUpdateRefVariable(dateValue),
      country: useMakeReportFilterById(countries.value),
      campaign: useMakeReportFilterById(campaignFilter.value),
      conversionTypeGroup: useMakeReportFilter(payoutConversionFilter.value),
      usageType: useMakeReportFilter(usageTypeFilter?.value, { matchType: "contains" }),
      subId: useMakeReportFilter(subIdFilter?.value),
      keyword: useMakeReportFilter(keywordFilter?.value),
    },
    fields: updateSortFields(selectedColumns),
    first: useUpdateRefVariable(count),
    page: useUpdateRefVariable(currentPage),
    options: [],
    sortOrder: tableSortByValue.value,
    export: false,
  }
})


const reportQueryOptions = ref({
  fetchPolicy: "cache-first",
})

const refreshReportData = () => {
  if (loading.value == true) {
    return
  }

  activeColumns.value = selectedColumns.value

  const currentVars = JSON.parse(JSON.stringify(reportVariables.value))
  load(PUBLISHER_REPORT_QUERY, currentVars, reportQueryOptions) ||
    refetch(currentVars)
}

// Close date picker function
const closeDatePicker = () => {
  // Try to close the picker by clicking outside or programmatically
  const pickerElement = document.querySelector('.datetimepicker')
  if (pickerElement) {
    // Simulate clicking outside to close
    document.body.click()
  }
  datePickerOpen.value = false
}

onMounted(() => {
  refreshReportData()
  
  // Initialize date picker state
  datePickerOpen.value = false
  
  // Listen for click events on the date picker input to open
  setTimeout(() => {
    const dateInput = document.querySelector('#date-preset-picker-input')
    if (dateInput) {
      dateInput.addEventListener('click', () => {
        setTimeout(() => {
          datePickerOpen.value = true
        }, 50)
      })
    }
  }, 500)
  
  // Listen for clicks outside to close
  document.addEventListener('click', (event) => {
    const datePicker = document.querySelector('.datetimepicker')
    const dateInput = document.querySelector('#date-preset-picker-input')
    
    if (datePickerOpen.value && datePicker && dateInput) {
      if (!datePicker.contains(event.target) && !dateInput.contains(event.target)) {
        setTimeout(() => {
          const stillVisible = document.querySelector('.datetimepicker')
          if (!stillVisible) {
            datePickerOpen.value = false
          }
        }, 100)
      }
    }
  })
})

// Watch for column changes and refresh data
watch(selectedColumns, () => {
  refreshReportData()
}, { deep: true })

// Watch for date range changes and refresh data
watch(dateValue, () => {
  refreshReportData()
}, { deep: true })

const {
  onResult: onUserReport,
  loading,
  load,
  refetch,
} = useLazyQuery(
  PUBLISHER_REPORT_QUERY,
  JSON.parse(JSON.stringify(reportVariables.value)),
  reportQueryOptions,
)

onUserReport(queryResult => {
  if (queryResult.data !== undefined) {
    reportResults.value = queryResult.data.report.data
    reportTotals.value = queryResult.data.report.totals
  }
})

const publisherCampaignVariables = computed(() => ({
  filters: {
    status: "subscribed",
    isFullyActive: true,
  },
  first: 500,
  page: 1,
}))

const { onResult: onCampaignsResult } = useQuery(
  PUBLISHER_REDIRECTS_LITE_QUERY,
  publisherCampaignVariables,
  {
    enabled: computed(() => authStore?.authUser?.id != undefined),
  },
)

onCampaignsResult(queryResult => {
  if (queryResult.data == undefined) {
    return
  }
  campaignOptions.value = queryResult.data.publisherRedirects.data
    .filter(item => item.campaign)
    .map(item => {
      return { label: item.campaign?.label, id: item.campaign?.id }
    })
})

function loadPage(page) {
  currentPage.value = page
}
function nextPage() {
  currentPage.value++
}
function previousPage() {
  currentPage.value--
}

// Export functions
const exportAsJson = () => {
  if (!reportResults.value || reportResults.value.length === 0) {
    return
  }

  // Filter data to only include selected columns
  const exportData = reportResults.value.map(row => {
    const filteredRow = {}
    activeColumns.value.forEach(column => {
      filteredRow[column.label] = row[column.name]
    })
    return filteredRow
  })

  const jsonString = JSON.stringify(exportData, null, 2)
  const blob = new Blob([jsonString], { type: 'application/json' })
  const timestamp = DateTime.now().toFormat('yyyy-MM-dd_HHmm')
  saveAs(blob, `publisher_report_${timestamp}.json`)
}

const exportAsCsv = () => {
  if (!reportResults.value || reportResults.value.length === 0) {
    return
  }

  // Filter data to only include selected columns
  const exportData = reportResults.value.map(row => {
    const filteredRow = {}
    activeColumns.value.forEach(column => {
      filteredRow[column.label] = row[column.name]
    })
    return filteredRow
  })

  const csvString = objectToCsv(exportData)
  const timestamp = DateTime.now().toFormat('yyyy-MM-dd_HHmm')
  saveCsvString(csvString, `publisher_report_${timestamp}.csv`)
}
</script>

<style scoped>
/* Mobile column badges with checkmarks */
/* .column-badge::before {
  content: "✓";
  @apply absolute left-1.5 text-primary-content font-bold text-xs;
} */

/* Light mode - white text and checkmarks */
html[data-theme="day"] .column-badge {
  @apply text-white;
}

html[data-theme="day"] .column-badge::before {
  @apply text-white;
}

html[data-theme="day"] .column-badge button {
  @apply text-white/70 hover:text-white hover:bg-white/20;
}

/* Light mode checkboxes - light checkmarks */
html[data-theme="day"] .checkbox-primary:checked {
  @apply bg-primary border-primary;
  --chkbg: oklch(var(--p));
  --chkfg: white;
}

.th-node {
  @apply px-1 py-1;
}
.th-span-node {
  @apply px-2 py-2 bg-base-100 block rounded-md w-full hover:bg-primary hover:text-white flex justify-between h-[3.4rem] sm:h-auto;
}

.th-node:first-child {
  @apply !px-1 !py-1;
}

.sort-icon {
  height: 0.75rem;
  display: inline-block;
  margin-right: 0.65rem;
  /* margin-bottom: 3px; */
  opacity: 20%;
  stroke-width: 4px;
}
.sort-icon-selected {
  @apply text-accent;
  opacity: 100% !important;
  stroke-width: 4px;
}

.ai-input-label {
  @apply rounded-full
    absolute 
    text-sm 
    duration-200 
    -translate-y-1/2
    scale-100
    origin-[0]
    px-1
    mx-0.5
    scale-75
    top-0
    bg-base-100
    peer-focus:top-0
    peer-placeholder-shown:px-2
    peer-focus:px-1
    peer-placeholder-shown:text-neutral-content
    peer-placeholder-shown:scale-100
    peer-placeholder-shown:-translate-y-1/2
    peer-placeholder-shown:top-1/2

    peer-focus:scale-75
    peer-focus:text-white
    rtl:peer-focus:translate-x-1/4
    rtl:peer-focus:left-auto
    start-1
    peer-placeholder-shown:text-neutral-content/50 
    peer-focus:text-neutral-content 
    dark:peer-focus:text-white;
}
</style>
